<div class="top-bar">
  <div class="branding">
    @if (environmentName) {
      <div class="name">
        {{environmentName}}
      </div>
    }

    @if (signalRConnected === false) {
      <div class="realtime-status warning">
        <i class="warning-icon fas fa-exclamation-triangle"></i>
        <span class="text-x-small">{{'Connection error' | translate}}. {{'Data shown can be old' | translate }}. {{'Trying to reconnect' | translate }}</span>
        <app-connecting-animating-icon></app-connecting-animating-icon>
      </div>
    }
    @if (signalRConnected === undefined) {
      <div class="realtime-status">
        <app-connecting-animating-icon></app-connecting-animating-icon>
        <span class="text-x-small">{{'Connecting' | translate}}</span>
      </div>
    }
  </div>

  @if (!hideSearchBar) {
    <div class="search">
      <app-top-bar-search></app-top-bar-search>
    </div>
  }

  <div class="main-menu">
    <app-garage class="menu-item float-right"></app-garage>
    <app-user class="menu-item float-right"></app-user>
  </div>
</div>